// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"14da68e5","625":"44c5224c","874":"9bce7c68"}[chunkId] + ".chunk.js";
};